export const VisitCitationEmpty = () => (
  <span className="text-xs font-normal text-neutral-400">No citations</span>
);
